export default [
  {
    path: 'search_records',
    name: 'search_records.index',
    component: require('./index').default,
    meta: {
      title: '搜索管理',
      navbar: 'el-icon-search',
      permission: 'search_records.read'
    }
  },
  {
    path: 'search_records/:id',
    name: 'search_records.show',
    component: require('./show').default,
    meta: {
      title: '搜索记录详情',
      permission: 'search_records.read'
    }
  }
]
